console.log("In student.main.js");
let retailerStore = require('./retailer.student.store.js');
let param = Object.assign({}, window.retailer.param);
let stageThreeParam = Object.assign({}, retailer.stageThreeParam);
let prevWeek = 0;
let doms;
/*
1. at the beginning of competition, upon click start:
if (student, email, competition) tuple not found in db, create empty competition result on db. result id is sent to front
if (student, email, competition) tuple found in db,
    if found, and completed, can't replay
    if found, in the middle, resume from middle
2. after each round, send ajax to back using api/result. Update the result record.
*/
retailerStore.store.subscribe(() => render(retailerStore.store.getState()));
initJqueryDoms();
bindHandlers();
retailer.initChart();
if (getResultID()) {
    initViewSteps();
} else {
    initRound(window.retailer.freeplaySeed || retailer.randomInt(), true);
}

// GROUP0 render functions
function render(state) {
    function renderChart() {
        retailer.drawWithState(state.clientRoundData);
    }
    function renderTable() {
        for (let i = 0; i <= param.NUMBER_OF_WEEKS; i++) {
            let row = $('.w' + (i + 1), doms.gameTable);
            let week = Object.assign({
                price: '',
                sales: '',
                revenue: '',
            }, state.clientRoundData.weeks[i]);
            week.inventory = i === 0 ? stageThreeParam.INITIAL_INVENTORY :
                state.clientRoundData.weeks[i - 1] ? state.clientRoundData.weeks[i - 1].inventory : '';
            $('td:nth-child(2)', row).html(week.inventory);
            $('td:nth-child(3)', row).html(week.price);
            $('td:nth-child(4)', row).html(week.sales);
            $('td:nth-child(5)', row).html(week.revenue);
        }
    }
    function renderPerformance() {
        function getTotalRevenue() {
            let weeks = state.clientRoundData.weeks || [];
            return weeks.reduce((prev, cur) => prev + cur.revenue, 0);
        }
        let totalRevenue = getTotalRevenue();
        doms.performanceYourRev.html('$' + totalRevenue);
        if (!state.clientRoundData.isCompleted) {
            doms.performanceTextMax.css('visibility', 'hidden');
            doms.performanceMaxRev.css('visibility', 'hidden');
            doms.performancePercentage.css('visibility', 'hidden');
        } else {
            let optimalRevenue = state.clientRoundData.optimal.revenue;
            let performance = (totalRevenue * 100 / optimalRevenue).toFixed(2);
            doms.performanceMaxRev.html(optimalRevenue ? '$' + optimalRevenue : '-1');
            doms.performancePercentage.html(performance ? performance + '%' : '-1');
            doms.performanceTextMax.css('visibility', 'visible').fadeIn(600);
            doms.performanceMaxRev.css('visibility', 'visible').fadeIn(600);
            doms.performancePercentage.css('visibility', 'visible').fadeIn(600);
        }
    }
    function finishRoundWrapUp() {
        for (var i = 0; i <= doms.priceBtn.length - 1; i++)
            styleToDisabled(doms.priceBtn[i]);
        doms.samePriceBtn.removeClass('btn-info');
        doms.samePriceBtn.addClass('btn-success');
        doms.samePriceBtn.unbind('click');
        if (state.clientRoundData.competition_id) {
            if (state.clientRoundData.displayedRound < state.clientRoundData.currentRound || state.clientRoundData.currentRound === state.clientRoundData.totalRounds) {
                doms.samePriceBtn.html('Competition Summary');
                doms.samePriceBtn.click(handleGetCompetitionSummaryClick);
            } else {
                doms.samePriceBtn.html('Next round');
                doms.samePriceBtn.click(handleNextRoundBtnClick);
            }
        } else { // is freeplay
            doms.samePriceBtn.html('Replay');
            doms.samePriceBtn.click(handleFreePlayBtnClick);
        }
    }
    function alertFinishRound(finishConditionStr) {
        var finishStr = '';
        if (state.clientRoundData.competition_id) {
            if (state.clientRoundData.currentRound < state.clientRoundData.totalRounds)
                finishStr = finishConditionStr + ' You have finished Round [' + (state.clientRoundData.currentRound) + ']. Click "Next Round" button to enter Round [' + (state.clientRoundData.currentRound + 1) + ']. You performance for the rounds so far has been recorded, so if you quit now you can resume from next round onwards.';
            else
                finishStr = finishConditionStr + ' You have finished all ' + state.clientRoundData.totalRounds + ' Rounds. Click "Competition Summary" button to see your performance summary. You will not be allowed to attempt it again with the same name and email.';
        } else {
            finishStr = finishConditionStr + ' You have finished the round!';
        }
        alert(finishStr);
    }
    function checkFinishRound() {
        if (getClientRoundData().isCompleted) {
            if (!state.clientRoundData.isView) {
                if (getClientRoundData().weeks[param.NUMBER_OF_WEEKS - 1].inventory == 0)
                    alertFinishRound('All units are sold out.');
                else
                    alertFinishRound('');
            }
            finishRoundWrapUp();
        }
    }
    renderChart();
    renderTable();
    renderPerformance();
    initRoundDomCosmetic();
    if (state.clientRoundData.displayedRound != null && state.clientRoundData.currentRound != null) {
        if (1 < state.clientRoundData.displayedRound && state.clientRoundData.displayedRound <= state.clientRoundData.currentRound) {
            doms.previousRoundBtn.removeClass('disabled');
        } else {
            doms.previousRoundBtn.addClass('disabled');
        }
        if (state.clientRoundData.displayedRound < state.clientRoundData.currentRound) {
            doms.nextRoundBtn.removeClass('disabled');
        } else {
            doms.nextRoundBtn.addClass('disabled');
        }
    }
    checkFinishRound();
    if (state.clientRoundData.competition_id) {
        doms.currentRoundSpan.html('Current round: ' + state.clientRoundData.displayedRound + ' of ' + state.clientRoundData.totalRounds);
        $('.competition-name-b').html(state.clientRoundData.competition_id);
    }
    prevWeek = state.clientRoundData.weeks.length;
}
// GROUP1 init functions
function initViewSteps() {
    let result_id = getResultID();
    retailer.apiViewSteps({
        result_id: result_id
    }, (data) => {
        doms.freePlayTab.parent().removeClass('active');
        doms.competitionTab.parent().addClass('active');
        doms.freePlayTab.parent().addClass('hidden');
        doms.competitionSummaryTab.parent().removeClass('hidden');
        doms.roundTraverseDiv.show();
        doms.priceBtnDiv.hide();
        doms.viewStepsDiv.show();
        $('#viewing-name-value').html(data.data.studentName);
        let round = '';
        round += data.data.currentRound;
        round += ' round(s) of ';
        round += data.data.totalRounds;
        round += ' round(s)';
        $('#viewing-rounds-value').html(round);
        retailerStore.dispatch('api.PostRoundPriceAction', data);
    });
}
function initJqueryDoms() {
    function makeClipboardBtn() {
        //if (retailer.isIOS()) {
        //    doms.copyTableBtn.css('display', 'none');
        //}
        //else {
        //doms.tableClipboard = retailer.makeTableClipboard(doms.copyTableBtn, doms.gameTable[0]);
        //}
        doms.tableClipboard = retailer.makeTableClipboard(doms.copyTableBtn.selector);
    }
    function setPriceBtnText() {
        for (let i = 0; i < stageThreeParam.PRICE_LABEL.length; i++)
            doms.priceBtn[i].html(stageThreeParam.PRICE_LABEL[i]);
    }
    function getCompetitionIDs() {
        retailer.apiCompetitionListForStudent((data) => {
            doms.competitionIdSelect.empty();
            for (let i = 0; i < data.data.length; i++) {
                doms.competitionIdSelect.append('<option data-owner="' + data.data[i].owner + '" data-id="' + data.data[i].competition_id
                    + '" value="' + data.data[i].competition_id
                    + '">' + data.data[i].competition_id + '</option>');
            }
        });
    }
    // cache these jquery obj for repeated use
    doms = {
        competitionModal: $('#competition-modal'),
        studentKeyModal: $('#student-key-modal'),
        currentRoundSpan: $('#current-round'),
        competitionSummaryModal: $('#competition-summary-modal'),
        competitionSummary: $('#competition-summary'),
        competitionIdSelect: $('select.competition-id-select').combobox(),
        comboboxBtn: $('span.ui-combobox .ui-combobox-button'),
        comboboxInput: $('span.ui-combobox .ui-combobox-input').addClass('form-control'),
        competitionInputs: $('#competition-form').find('input'),
        studentKeyInputs: $('#student-key-form').find('input'),
        competitionSummaryTable: $('.competition-summary-table'),
        performanceMaxRev: $('.performance-maxRev'),
        performanceTextMax: $('.performance-text-max'),
        performanceBreakdownDiv: $('.performance-breakdown'),
        performancePercentage: $('.performance-percentage'),
        performanceYourRev: $('.performance-yourRev'),
        priceBtn: [$('.full-price-btn'), $('.ten-percent-btn'), $('.twenty-percent-btn'), $('.fourty-percent-btn')],
        priceBtnDiv: $('.game-pricing-btns-div'),
        viewStepsDiv: $('.view-steps-info-div'),
        samePriceBtn: $('.same-price-btn'),
        freePlayTab: $('a.free-play-btn'),
        competitionTab: $('a.competition-btn'),
        competitionSummaryTab: $('a.competition-summary-btn'),
        startCompBtn: $('#startCompetitionButton'),
        getStudentKeyBtn: $('#getStudentKeyButton'),
        roundTraverseDiv: $('#roundTraverseDiv'),
        previousRoundBtn: $('#showPreviousRoundButton'),
        nextRoundBtn: $('#showNextRoundButton'),
        gameTable: $('table.game-table'),
        copyTableBtn: $('.copy-table-btn'),
        copyTableModal: $('#copyTableModal'),
        tableClipboard: null
    };
    makeClipboardBtn();
    setPriceBtnText();
    $('body').nodoubletapzoom();
    $('.price-btn').nodoubletapzoom();
    doms.priceBtnDiv.nodoubletapzoom();
    doms.priceBtnDiv.find('table').nodoubletapzoom();
    doms.priceBtnDiv.find('tr').nodoubletapzoom();
    doms.priceBtnDiv.find('tbody').nodoubletapzoom();
    doms.priceBtnDiv.find('td').nodoubletapzoom();
    getCompetitionIDs();
}
function bindHandlers() {
    doms.priceBtnDiv.on('click', '.full-price-btn, .ten-percent-btn, .twenty-percent-btn, .fourty-percent-btn', handlePriceBtnClick);
    doms.competitionTab.click(handleCompetitionBtnClick);
    doms.freePlayTab.click(handleFreePlayBtnClick);
    doms.startCompBtn.click(handleStartCompetitionClick);
    doms.getStudentKeyBtn.click(handleGetStudentKeyClick);
    doms.competitionSummaryTab.click(handleGetCompetitionSummaryClick);
    doms.previousRoundBtn.click(handlePreviousRoundClick);
    doms.nextRoundBtn.click(handleNextRoundClick);
}

// GROUP2 round functions
function initRound(seed, isFreeplay) {
    initRoundDomCosmetic(true);
    console.log(`In initRound seed: ${seed} isFreeplay: ${isFreeplay}`);
    if (isFreeplay) {
        doms.roundTraverseDiv.hide();
        retailerStore.dispatch('seed', seed);
    }
    //doms.viewStepsDiv.hide();
    initRoundDomCosmetic();
    // if weekone price decision is fixed at Full price, auto move to Week 2 
    if (param.IS_FIXED_WEEKONE) {
        stepOneWeek(0);
    }
}
function stepOneWeek(action) {
    console.log('In stepOneWeek');
    if (doms.competitionTab.parent().hasClass('active')) {
        var userInput = getAndCheckCompetitionInput();
        retailer.apiCompetitionRoundPriceAction({
            competition_id: userInput.competition_id,
            studentEmail: userInput.studentEmail,
            studentKey: userInput.studentKey,
            priceAction: action
        }, (data) => {
            retailerStore.dispatch('api.PostRoundPriceAction', data);
        });
    } else {
        var priceActions;
        if (getClientRoundData().priceActions.length == 0) {
            priceActions = [action];
        } else {
            priceActions = getClientRoundData().priceActions;
            priceActions = priceActions.concat(action);
        }
        retailer.apiPostFreeplayRoundPriceAction({
            seed: getClientRoundData().seed,
            priceActions: priceActions
        }, (data) => {
            retailerStore.dispatch('api.PostRoundPriceAction', data);
        });
    }
}
// GROUP3 handlers
function handlePreviousRoundClick(e) {
    let req = generateRoundTravseInput();
    req.round = Math.max(1, getClientRoundData().displayedRound - 1);
    postRoundTraveseAction(req);
}
function handleNextRoundClick(e) {
    let req = generateRoundTravseInput();
    req.round = Math.min(getClientRoundData().totalRounds, getClientRoundData().displayedRound + 1);
    postRoundTraveseAction(req);
}
function handleGetCompetitionSummaryClick(e) {
    function renderCompetitionInfo(competitionInfo) {
        let html = "";
        html += "<form id='competition-form'>" +
            '<div class="form-group">' +
            '<label for="Competition ID">Competition ID</label>' +
            '<input class="form-control" name="competition_ID" readonly value="' + competitionInfo.competition_id + '"/>' +
            "<label>Email</label><br>" +
            "<input type='text' class='form-control' readonly name='competitor_email' value='" + competitionInfo.studentEmail + "'/>" +
            "</div>" +
            "</form>";
        doms.competitionSummary.html(html);
    }
    function renderSummaryTable(data) {
        let table = "<thead>" +
            "<tr>" +
            "<th>Round</th>" +
            "<th>Revenue</th>" +
            "<th>Performance</th>" +
            "</tr>" +
            "</thead>" +
            "<tbody>";
        let averagePerformance = 0, completedRounds = 0, totalRevenue = 0;
        for (var i = 0; i < data.data.totalRounds; i++) {
            table += "<tr>";
            table += "<td>";
            table += (i + 1);
            table += "</td>";
            table += "<td>";
            if (data.data.clientRoundDataArr[i] != undefined) {
                table += data.data.clientRoundDataArr[i].revenue;
                totalRevenue += data.data.clientRoundDataArr[i].revenue;
            } else {
                table += 'Not done';
            }
            table += "</td>";
            table += "<td>";
            if (data.data.clientRoundDataArr[i] != undefined) {
                let performance = data.data.clientRoundDataArr[i].revenue * 100 / data.data.clientRoundDataArr[i].optimal;
                table += performance.toFixed(2);
                table += "%";
                averagePerformance += performance;
                completedRounds += 1;
            } else {
                table += 'Not done';
            }
            table += "</td>";
            table += "</tr>";
        }
        table += "<tr>";
        table += "<td>";
        table += "Summary";
        table += "</td>";
        table += "<td>";
        table += totalRevenue;
        table += "</td>";
        table += "<td>";
        if (completedRounds) {
            table += ((averagePerformance / completedRounds * 100) / 100.0).toFixed(2);
        } else {
            table += (0.0).toFixed(2);
        }
        table += "%";
        table += "</td>";
        table += "</tr>";
        table += "</tbody>";
        doms.competitionSummaryTable.html(table);
        doms.competitionSummaryModal.modal('show');
    }
    if (getResultID()) {
        retailer.apiViewSteps({
            result_id: getResultID(),
            isSummary: true
        }, (data) => {
            let competitionInfo = {
                competition_id: data.data.competition_id,
                studentEmail: data.data.studentEmail
            };
            renderCompetitionInfo(competitionInfo);
            renderSummaryTable(data);
        });
    } else {
        let userInput = getAndCheckCompetitionInput();
        retailer.apiGetCompetitionData(userInput, (data) => {
            let competitionInfo = {
                competition_id: data.data.competition_id,
                studentEmail: data.student.email,
            }
            renderCompetitionInfo(competitionInfo);
            renderSummaryTable(data);
        });
    }

}
function handlePriceBtnClick(e) {
    console.log('handlePriceBtnClick');
    //if ($(this).hasClass('active') || $(this).hasClass('disabled')) {
    //allow players to click the same price button to set same price
    if ($(this).hasClass('disabled')) {
        return false;
    }
    let action = $(this).attr('data-price') === 'same' ? getPriceIndex() : parseInt($(this).attr('data-priceIndex')) - 1;
    stepOneWeek(action);
}
function handleGetStudentKeyClick(e) {
    var values = {};
    doms.studentKeyInputs.each(function () {
        values[this.name] = _.escape($(this).val());
    });
    console.log("The raw userinputs: ", values);
    if (!values.competitor_email) {
        alert("Please fill up all registration infomation!");
    } else if (!retailer.validateEmail(values.competitor_email)) {
        alert('Please provide correct email!');
    } else
        retailer.apiSendStudentKey({ 'email': values.competitor_email, 'name': values.competitor_name });
}
function handleStartCompetitionClick(e) {
    function initCompetition(userInput) {
        console.log('In initCompetition');
        retailer.apiGetCompetitionRoundData(userInput
            , (data) => {
                if (data.data.isRobot) {
                    alert('You cannot play a robot competition using this interface!');
                    return false;
                }
                resetStore();
                doms.freePlayTab.parent().removeClass('active');
                doms.competitionTab.parent().addClass('active');
                doms.competitionSummaryTab.parent().removeClass('hidden');
                doms.roundTraverseDiv.show();
                if (data.data.currentRound == null) {
                    alert('You have yet to attempt this competition, starting now!');
                    if (param.IS_FIXED_WEEKONE) {
                        stepOneWeek(0);
                    }
                } else {
                    alert('Your record is found and you were at round ' + data.data.currentRound + '. You will resume from there.');
                    retailerStore.dispatch('api.PostRoundPriceAction', data);
                }

            });
        return true;
    }
    function hideCompetitionModal(values) {
        $(this).addClass('disabled');
        doms.startCompBtn.tooltip({
            html: true,
            title: '<span style="font-size: 12px;">Entering Competition ' + values.competition_id + '</span>',
            trigger: 'manual',
        });
        doms.startCompBtn.tooltip('show');
        doms.startCompBtn.on('hidden.bs.tooltip', function (e) {
            doms.competitionModal.modal('hide');
        });
        (function (el) {
            setTimeout(function () {
                $(el).tooltip('hide');
            }, 1000);
        })(doms.startCompBtn);
    }
    var userCompetitionInputs = getAndCheckCompetitionInput();
    if (!userCompetitionInputs) {
        return false;
    }
    initCompetition(userCompetitionInputs) && hideCompetitionModal.apply(this, [userCompetitionInputs]);
}
function handleNextRoundBtnClick(e) {
    console.log('In handleNextRoundBtnClick');
    initRound(null, false);
}
function handleFreePlayBtnClick(e) {
    console.log('In handleFreePlayBtnClick');
    var isStartNewRound;
    if (doms.competitionTab.parent().hasClass('active')) {
        isStartNewRound = window.confirm("Are you sure to leave the current Competition and start a Free Play?");
    } else {
        isStartNewRound = window.confirm("Are you sure to start a new round?");
    }
    if (isStartNewRound) {
        doms.freePlayTab.parent().addClass('active');
        doms.competitionTab.parent().removeClass('active');
        doms.competitionSummaryTab.parent().addClass('hidden');
        clearStatus();
        initRound(retailer.randomInt(), true);
    }
}
function handleCompetitionBtnClick(e) {
    function fillCompetitorParticulars() {
        console.log('In fillCompetitorParticulars');
        var savedCompetitionDetails = null;
        if (!(savedCompetitionDetails = window.localStorage.getItem('retailer')))
            return;
        savedCompetitionDetails = JSON.parse(savedCompetitionDetails);
        doms.competitionInputs.each(function (i, el) {
            if (el.tagName.toUpperCase() == 'INPUT') {
                var savedValue = savedCompetitionDetails[el.name];
                $(el).val(savedValue);
            }
        });
    }
    console.log('In handleCompetitionBtnClick');
    if (doms.competitionTab.parent().hasClass('active')) {
        doms.startCompBtn.addClass('disabled');
        doms.competitionInputs.attr('readonly', 'readonly');
        doms.comboboxInput.attr('readonly', 'readonly');
        doms.comboboxBtn.addClass('disabled')
    } else {
        fillCompetitorParticulars();
        doms.startCompBtn.removeClass('disabled');
    }
}
// GROUP4 misc and util functions
function postRoundTraveseAction(req) {
    if (getResultID()) {
        retailer.apiViewSteps(req, (data) => {
            retailerStore.dispatch('api.PostRoundPriceAction', data);
        });
    } else {
        retailer.apiGetCompetitionRoundData(req, (data) => {
            retailerStore.dispatch('api.PostRoundPriceAction', data);
        });
    }
}
function generateRoundTravseInput() {
    let req = {};
    if (getResultID()) {
        req = {
            result_id: getResultID()
        }
    } else {
        let userInput = getAndCheckCompetitionInput();
        req = {
            competition_id: userInput.competition_id,
            studentEmail: userInput.studentEmail,
            studentKey: userInput.studentKey
        }
    }
    return req;
}
function getPriceIndex() {
    let length = getClientRoundData().priceActions.length;
    return (length == 0) ? 0 : getClientRoundData().priceActions[length - 1];
}
function clearStatus() {
    console.log('in clearStatus');
    resetStore();
    doms.currentRoundSpan.html('Free Play');
    $('.competition-name-b').html('');
    doms.competitionInputs.val('');
    doms.competitionInputs.removeAttr('readonly');
    doms.comboboxInput.removeAttr('readonly');
    doms.comboboxBtn.removeClass('disabled');
    doms.freePlayTab.parent().addClass('active');
    doms.competitionTab.parent().removeClass('active');
}
function styleBtnByCurrentPrice(reset = false) {
    function styleToActive(btn) {
        btn.addClass('active').removeClass('disabled');
    }
    function styleToNone(btn) {
        btn.removeClass('active').removeClass('disabled').blur();
    }
    console.log('in styleBtnByCurrentPrice');
    let priceIndex = reset ? 0 : getPriceIndex();
    for (var i = 0; i < priceIndex; i++)
        styleToDisabled(doms.priceBtn[i]);
    styleToActive(doms.priceBtn[priceIndex]);
    for (i = priceIndex + 1; i < 4; i++)
        styleToNone(doms.priceBtn[i]);
    styleToNone(doms.samePriceBtn);
}
function styleToDisabled(btn) {
    btn.removeClass('active').addClass('disabled').blur();
}
function getClientRoundData() {
    return retailerStore.store.getState().clientRoundData;
}
function getAndCheckCompetitionInput() {
    console.log('in getAndCheckCompetitionInput');
    var values = {};
    doms.competitionInputs.each(function () {
        if ($(this).hasClass('competition-id-select')) {
            // console.log('XXXXXXX this is competition-id-select. value: ', _.escape(doms.competitionIdSelect.combobox().value()));
            // values[this.name] = _.escape(doms.competitionIdSelect.combobox().value());
        }
        else {
            values[this.name] = _.escape($(this).val());
        }
    });
    console.log("The raw userinputs: ", values);
    // if (!values.competition_ID || !values.competitor_email || !values.student_key) {
    //     alert("Please fill up all competition infomation!");
    // } else if (!retailer.validateEmail(values.competitor_email)) {
    //     alert('Please provide correct email!');
    // } else {
    //     window.localStorage.setItem('retailer', JSON.stringify(values));
    //     return {
    //         competition_id: values.competition_ID,
    //         studentEmail: values.competitor_email,
    //         studentKey: values.student_key
    //     };
    // }
    if (!values.competition_ID) {
        alert("Please fill up all competition infomation!");
    } else {
        window.localStorage.setItem('retailer', JSON.stringify(values));
        return {
            competition_id: values.competition_ID,
            //studentEmail: values.competitor_email,
            //studentKey: values.student_key
        };
    }
}
function initRoundDomCosmetic(reset = false) {
    doms.samePriceBtn.html('Same Price');
    doms.samePriceBtn.removeClass('btn-success');
    doms.samePriceBtn.addClass('btn-info');
    doms.samePriceBtn.unbind('click');
    doms.samePriceBtn.click(handlePriceBtnClick);
    styleBtnByCurrentPrice(reset);
}
function getResultID() {
    function findGetParameter(parameterName) {
        var result = null,
            tmp = [];
        var items = location.search.substr(1).split("&");
        for (var index = 0; index < items.length; index++) {
            tmp = items[index].split("=");
            if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        }
        return result;
    }
    return findGetParameter("result_id");
}
function resetStore() {
    retailerStore.dispatch('api.PostRoundPriceAction', {
        data: {
            totalRounds: null,
            currentRound: null,
            displayedRound: null,
            competition_id: null,
            clientRoundData: {
                optimal: null,
                seed: null,
                isCompleted: null,
                weeks: [],
                priceActions: [],
            }
        }
    });
}



// WEBPACK FOOTER //
// ../public/js/retailer.student.main.js